// @core/api/endpoints/apikey/resolve_api_key_context.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ResolveAPIKeyContextRequest,
  ResolveAPIKeyContextResponse,
} from '../../../types/apikey';

const BASE_PATH = '/apikey';

/**
 * Resolve API key context
 * Resolves the effective API key policy for a scope entity by merging the policy hierarchy.
 */
export async function ResolveAPIKeyContext(
  data: ResolveAPIKeyContextRequest,
  options?: RequestOptions
): Promise<ResolveAPIKeyContextResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/api-keys/resolve-context`;
  const requestOptions = options;
  return client.post<ResolveAPIKeyContextResponse>(requestPath, data, requestOptions);
}
